import {
  abi as mezoBridgeAbi,
  address as mezoBridgeAddress,
} from "@mezo-org/euphrates-contracts/deployments/ethereum/MezoBridge.json"
import { address as mezoBridgeTestnetAddress } from "@mezo-org/euphrates-contracts/deployments/sepolia/MezoBridge.json"
import { Abi, Address } from "viem"

import { IS_MEZO_MAINNET } from "../network"

const address = (
  IS_MEZO_MAINNET ? mezoBridgeAddress : mezoBridgeTestnetAddress
) as Address

export default {
  abi: mezoBridgeAbi as Abi,
  address,
}
